import { render, staticRenderFns } from "./FieldSetComponent.vue?vue&type=template&id=6bca3ba5&scoped=true&"
import script from "./FieldSetComponent.vue?vue&type=script&lang=js&"
export * from "./FieldSetComponent.vue?vue&type=script&lang=js&"
import style0 from "./FieldSetComponent.vue?vue&type=style&index=0&id=6bca3ba5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca3ba5",
  null
  
)

export default component.exports